import { Col, Row } from "reactstrap";

const Termos = ((props) => {
  
  const { termosText } = props;

  // function dataPorExtenso(city) {
  //   const hoje = new Date();

  //   const opcoes = {
  //     day: 'numeric',
  //     month: 'long',
  //     year: 'numeric',
  //   };

  //   // Formata a data para o português do Brasil
  //   const dataFormatada = hoje.toLocaleDateString('pt-BR', opcoes);

  //   // Capitaliza o mês apenas se necessário (opcional)
  //   return `${city}, ${dataFormatada}.`;
  // }

  return <Row>
    <Col>
      <div style={{
        width:"100%",
        height:"300px",
        padding:20,
        borderRadius:10,
        border:"1px solid #CCC",
        margin:10,
        overflowX:"hidden",
        overflowY:"auto"
        
      }}
      dangerouslySetInnerHTML={{ __html: termosText }}></div>
    </Col>
  </Row>
});

export default Termos;


